function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */
import React, { forwardRef } from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
var SvgHide = /*#__PURE__*/forwardRef(function (props, svgRef) {
  return ___EmotionJSX("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), ___EmotionJSX("path", {
    fill: "currentColor",
    d: "M4.929 2.101l3.746 3.746c1.197-.564 2.305-.846 3.325-.846 2.933 0 6.6 2.333 11 7-1.493 1.584-2.902 2.899-4.227 3.945l3.126 3.126-1.414 1.414L3.514 3.515l1.414-1.414zm.298 5.954l2.118 2.118a5 5 0 006.484 6.482l1.498 1.498c-1.197.564-2.305.846-3.325.846-2.933 0-6.6-2.333-11-7C2.495 10.415 3.904 9.1 5.229 8.054zm3.778 3.778l3.162 3.163A3 3 0 019 12.001l.005-.167zM12 7c-.645 0-1.261.122-1.828.345l1.66 1.66A3 3 0 0114.999 12l-.006.167 1.662 1.661a5 5 0 00-4.656-6.827z"
  }));
});
export default SvgHide;